/* eslint-disable new-cap */
import { put, takeLatest } from "redux-saga/effects";
import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";
import { defaultReturn, makePayload, generateDefaultActions, requestSaga, handleCallback } from "shared-utility/store/utils/helpers";

const sagas = {};

export const EMAIL_CAMPAIGN_PREPAYMENT_GET = generateDefaultActions("EMAIL_CAMPAIGN_PREPAYMENT_GET");
export const getPrepayment = payload => makePayload(EMAIL_CAMPAIGN_PREPAYMENT_GET.value, payload);
sagas.getPrepaymentSaga = function* getPrepaymentSaga({ dealId, ssId }) {
  const url = `/edc/prepayment/${dealId}?ssId=${ssId}`;
  yield requestSaga(EMAIL_CAMPAIGN_PREPAYMENT_GET, url, "GET");
};

export const EMAIL_CAMPAIGN_PREPAYMENT_RESET = "EMAIL_CAMPAIGN_PREPAYMENT_RESET";
export const resetEmailCampaignPrepayment = () => ({ type: EMAIL_CAMPAIGN_PREPAYMENT_RESET });

export const EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_RESET = "EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_RESET";
export const resetEmailCampaignValuationSensitivity = () => ({ type: EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_RESET });

export const EMAIL_CAMPAIGN_GET_MASTER_CONTACT_LIST = generateDefaultActions("EMAIL_CAMPAIGN_GET_MASTER_CONTACT_LIST");
export const getMasterContactList = payload => makePayload(EMAIL_CAMPAIGN_GET_MASTER_CONTACT_LIST.value, payload);
sagas.getMasterContactListSaga = function* getMasterContactListSaga({ sponsorCompany }) {
  const sponsorCompanyQuery = (sponsorCompany) ? `?sponsorCompany=${sponsorCompany}` : "";
  const url = `/edc/contacts${sponsorCompanyQuery}`;
  yield requestSaga(EMAIL_CAMPAIGN_GET_MASTER_CONTACT_LIST, url, "GET");
};

export const EMAIL_CAMPAIGN_POST_MASTER_CONTACT_LIST = generateDefaultActions("EMAIL_CAMPAIGN_POST_MASTER_CONTACT_LIST");
export const saveMasterContactList = payload => makePayload(EMAIL_CAMPAIGN_POST_MASTER_CONTACT_LIST.value, payload);
sagas.saveMasterContactListSaga = function* saveMasterContactListSaga(payload) {
  const url = "/edc/contacts";
  yield requestSaga(EMAIL_CAMPAIGN_POST_MASTER_CONTACT_LIST, url, "POST", payload);
};

export const EMAIL_CAMPAIGN_GET_PREPAYMENT_SNAPSHOT = generateDefaultActions("EMAIL_CAMPAIGN_GET_PREPAYMENT_SNAPSHOT");
export const getPrepaymentSnapshot = payload => makePayload(EMAIL_CAMPAIGN_GET_PREPAYMENT_SNAPSHOT.value, payload);
sagas.getPrepaymentSnapshotSaga = function* getPrepaymentSnapshotSaga({ dealId, ssId, pin }) {
  const url = `/edc/prepayment/snapshot/${dealId}?ssId=${ssId}&pin=${pin}`;
  yield requestSaga(EMAIL_CAMPAIGN_GET_PREPAYMENT_SNAPSHOT, url, "GET");
};

export const EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_GET = generateDefaultActions("EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_GET");
export const getValuationSensitivity = payload => makePayload(EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_GET.value, payload);
sagas.getValuationSensitivitySaga = function* getValuationSensitivitySaga({ dealId, ssId }) {
  const url = `/edc/valuation/${dealId}?ssId=${ssId}`;
  yield requestSaga(EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_GET, url, "GET");
};

export const EMAIL_CAMPAIGN_GET_VALUATION_SNAPSHOT = generateDefaultActions("EMAIL_CAMPAIGN_GET_VALUATION_SNAPSHOT");
export const getValuationSensitivitySnapshot = payload => makePayload(EMAIL_CAMPAIGN_GET_VALUATION_SNAPSHOT.value, payload);
sagas.getValuationSensitivitySnapshotSaga = function* getValuationSensitivitySnapshotSaga({ dealId, ssId, pin }) {
  const url = `/edc/valuation/snapshot/${dealId}?ssId=${ssId}&pin=${pin}`;
  yield requestSaga(EMAIL_CAMPAIGN_GET_VALUATION_SNAPSHOT, url, "GET");
};

export const EMAIL_CAMPAIGN_GET_CAMPAIGN_TYPES = generateDefaultActions("EMAIL_CAMPAIGN_GET_CAMPAIGN_TYPES");
export const getCampaignTypes = payload => makePayload(EMAIL_CAMPAIGN_GET_CAMPAIGN_TYPES.value, payload);
sagas.getCampaignTypesSaga = function* getCampaignTypesSaga() {
  const url = "/edc/campaign-type";
  yield requestSaga(EMAIL_CAMPAIGN_GET_CAMPAIGN_TYPES, url, "GET");
};

export const EMAIL_CAMPAIGN_RESET_CAMPAIGN = generateDefaultActions("EMAIL_CAMPAIGN_RESET_CAMPAIGN");
export const resetCampaign = payload => makePayload(EMAIL_CAMPAIGN_RESET_CAMPAIGN.value, payload);
sagas.resetCampaignSaga = function* resetCampaignSaga(payload) {
  yield put(EMAIL_CAMPAIGN_RESET_CAMPAIGN.createSuccess(payload));
};

export const EMAIL_CAMPAIGN_CREATE_CAMPAIGN = generateDefaultActions("EMAIL_CAMPAIGN_CREATE_CAMPAIGN");
export const createEmailCampaign = payload => makePayload(EMAIL_CAMPAIGN_CREATE_CAMPAIGN.value, payload);
sagas.createEmailCampaignSaga = function* createEmailCampaignSaga(payload) {
  try {
    const callback = handleCallback(payload);
    const url = "/edc/campaign";
    yield requestSaga(EMAIL_CAMPAIGN_CREATE_CAMPAIGN, url, "POST", payload);
    yield callback();
  } catch (error) {
    yield put(EMAIL_CAMPAIGN_CREATE_CAMPAIGN.createFailure(error));
  }
};

export const EMAIL_CAMPAIGN_GET_CAMPAIGNS = generateDefaultActions("EMAIL_CAMPAIGN_GET_CAMPAIGNS");
export const getEmailCampaigns = payload => makePayload(EMAIL_CAMPAIGN_GET_CAMPAIGNS.value, payload);
sagas.getEmailCampaignsSaga = function* getEmailCampaignsSaga({ campaignStatusId }) {
  try {
    const url = `/edc/campaigns?campaignStatusId=${campaignStatusId}`;
    yield requestSaga(EMAIL_CAMPAIGN_GET_CAMPAIGNS, url, "GET");
  } catch (error) {
    yield put(EMAIL_CAMPAIGN_GET_CAMPAIGNS.createFailure(error));
  }
};

export const EMAIL_CAMPAIGN_GET_CAMPAIGN = generateDefaultActions("EMAIL_CAMPAIGN_GET_CAMPAIGN");
export const getEmailCampaign = payload => makePayload(EMAIL_CAMPAIGN_GET_CAMPAIGN.value, payload);
sagas.getEmailCampaignSaga = function* getEmailCampaignSaga({ campaignId }) {
  try {
    const url = `/edc/campaign/${campaignId}`;
    yield requestSaga(EMAIL_CAMPAIGN_GET_CAMPAIGN, url, "GET");
  } catch (error) {
    yield put(EMAIL_CAMPAIGN_GET_CAMPAIGNS.createFailure(error));
  }
};

export const EMAIL_CAMPAIGN_DELETE_CAMPAIGN = generateDefaultActions("EMAIL_CAMPAIGN_DELETE_CAMPAIGN");
export const deleteEmailCampaign = payload => makePayload(EMAIL_CAMPAIGN_DELETE_CAMPAIGN.value, payload);
sagas.deleteEmailCampaignSaga = function* deleteEmailCampaignSaga({ campaignId }) {
  const url = `/edc/campaign/${campaignId}`;
  yield requestSaga(EMAIL_CAMPAIGN_DELETE_CAMPAIGN, url, "DELETE");
};

export const EMAIL_CAMPAIGN_UPDATE_CAMPAIGN = generateDefaultActions("EMAIL_CAMPAIGN_UPDATE_CAMPAIGN");
export const updateEmailCampaign = payload => makePayload(EMAIL_CAMPAIGN_UPDATE_CAMPAIGN.value, payload);
sagas.updateEmailCampaignSaga = function* updateEmailCampaignSaga(payload) {
  const callback = handleCallback(payload);
  const url = `/edc/campaign/${payload.campaignId}`;
  yield requestSaga(EMAIL_CAMPAIGN_UPDATE_CAMPAIGN, url, "PUT", payload);
  yield callback();
};

export const EMAIL_CAMPAIGN_TOGGLE_DEAL_ACTIVE = generateDefaultActions("EMAIL_CAMPAIGN_TOGGLE_DEAL_ACTIVE");
export const toggleDealCampaign = payload => makePayload(EMAIL_CAMPAIGN_TOGGLE_DEAL_ACTIVE.value, payload);
sagas.toggleDealCampaignSaga = function* toggleDealCampaignSaga({ campaignId, dealId }) {
  const url = `/edc/campaign/${campaignId}/${dealId}/active`;
  const url2 = `/edc/campaign/${campaignId}`;
  yield requestSaga(EMAIL_CAMPAIGN_TOGGLE_DEAL_ACTIVE, url, "PUT", {});
  yield requestSaga(EMAIL_CAMPAIGN_GET_CAMPAIGN, url2, "GET");
};

export const EMAIL_CAMPAIGN_IS_EMAIL_COMPOSED_FLAG_TOGGLE = generateDefaultActions("EMAIL_CAMPAIGN_IS_EMAIL_COMPOSED_FLAG_TOGGLE");
export const toggleCampaignEmailIsComposedFlag = payload => makePayload(EMAIL_CAMPAIGN_IS_EMAIL_COMPOSED_FLAG_TOGGLE.value, payload);
sagas.toggleCampaignEmailIsComposedFlagSaga = function* toggleCampaignEmailIsComposedFlagSaga(payload) {
  const url = `/campaigns/${payload.campaignId}/updateEmailComposed`;
  yield requestSaga(EMAIL_CAMPAIGN_IS_EMAIL_COMPOSED_FLAG_TOGGLE, url, "PUT", {});
};

export const EMAIL_CAMPAIGN_UPDATE_EMAIL = generateDefaultActions("EMAIL_CAMPAIGN_UPDATE_EMAIL");
export const updateEmailCampaignEmail = payload => makePayload(EMAIL_CAMPAIGN_UPDATE_EMAIL.value, payload);
sagas.updateEmailCampaignEmailSaga = function* updateEmailCampaignEmailSaga({ campaignId, email }, callAgain) {
  const url = `/edc/campaigns/${campaignId}/email`;
  const url2 = `/edc/campaigns/${campaignId}`;
  yield requestSaga(EMAIL_CAMPAIGN_UPDATE_EMAIL, url, "PUT", { email });
  if (callAgain) {
    yield requestSaga(EMAIL_CAMPAIGN_GET_CAMPAIGN, url2, "GET");
  }
};

const initialState = {
  campaign: {},
  campaignTypes: [],
  prepayment: [],
  prepaymentError: false,
  prepaymentLoading: false,
  prepaymentSnapshot: [],
  campaigns: [],
  valuationSensitivity: [],
  valuationSensitivityError: false,
  valuationSensitivityLoading: false,
  valuationSensitivitySnapshot: {},
  masterContactList: [],
  canAddOrRemoveDeals: true
};

// eslint-disable-next-line default-param-last
export function emailCampaignReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMAIL_CAMPAIGN_TOGGLE_DEAL_ACTIVE.success:
      return defaultReturn(state, false, "canAddOrRemoveDeals");
    case EMAIL_CAMPAIGN_GET_CAMPAIGN_TYPES.success:
      return defaultReturn(state, payload.data, "campaignTypes");

    case EMAIL_CAMPAIGN_RESET_CAMPAIGN.success:
      return { ...state, campaign: {} };

    case EMAIL_CAMPAIGN_CREATE_CAMPAIGN.success:
      return defaultReturn(state, payload, "campaign");

    case EMAIL_CAMPAIGN_GET_CAMPAIGNS.success:
      return defaultReturn(state, payload.data, "campaigns");

    case EMAIL_CAMPAIGN_PREPAYMENT_GET.value:
      return { ...state, prepayment: [], prepaymentError: false, prepaymentLoading: true };

    case EMAIL_CAMPAIGN_PREPAYMENT_GET.success:
      return { ...state, prepayment: payload.data, prepaymentError: false, prepaymentLoading: false };

    case EMAIL_CAMPAIGN_PREPAYMENT_GET.failure:
      return { ...state, prepayment: [], prepaymentError: true, prepaymentLoading: false };

    case EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_GET.value:
      return { ...state, valuationSensitivity: [], valuationSensitivityError: false, valuationSensitivityLoading: true };

    case EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_GET.success:
      return { ...state, valuationSensitivity: payload.data, valuationSensitivityError: false, valuationSensitivityLoading: false };

    case EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_GET.failure:
      return { ...state, valuationSensitivity: [], valuationSensitivityError: false, valuationSensitivityLoading: false };

    case EMAIL_CAMPAIGN_CREATE_CAMPAIGN.failure:
      ToastError("Failed to Create The Email Engagement");

      return state;

    case EMAIL_CAMPAIGN_GET_PREPAYMENT_SNAPSHOT.success:
      return defaultReturn(state, payload.data, "prepaymentSnapshot");

    case EMAIL_CAMPAIGN_GET_VALUATION_SNAPSHOT.success:
      return defaultReturn(state, payload.data, "valuationSensitivitySnapshot");

    case EMAIL_CAMPAIGN_GET_VALUATION_SNAPSHOT.failure:
      return { ...state, valuationSensitivity: {} };

    case EMAIL_CAMPAIGN_PREPAYMENT_RESET:
      return { ...state, prepayment: [], prepaymentError: false, prepaymentLoading: false };

    case EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_RESET:
      return { ...state, valuationSensitivity: {}, valuationSensitivityError: false, valuationSensitivityLoading: false };

    case EMAIL_CAMPAIGN_GET_MASTER_CONTACT_LIST.success:
      return defaultReturn(state, payload.data, "masterContactList");

    case EMAIL_CAMPAIGN_POST_MASTER_CONTACT_LIST.success:
      ToastSuccess("Master Contact List Saved");

      return defaultReturn(state, payload.data, "masterContactList");

    case EMAIL_CAMPAIGN_GET_MASTER_CONTACT_LIST.success:
      return defaultReturn(state, payload.data, "masterContactList");

    case EMAIL_CAMPAIGN_GET_CAMPAIGN.success:
      return { ...state, campaign: payload.data, canAddOrRemoveDeals: true };

    case EMAIL_CAMPAIGN_DELETE_CAMPAIGN.success:
      return { ...state };

    case EMAIL_CAMPAIGN_UPDATE_CAMPAIGN.success:
      ToastSuccess("Email Engagement Update Successful");

      return { ...state };

    case EMAIL_CAMPAIGN_UPDATE_CAMPAIGN.failure:
      ToastError("Error Updating Email Engagement.");

      return { ...state };

    default:
      return state;
  }
}

export function* emailCampaignSaga() {
  yield takeLatest(EMAIL_CAMPAIGN_RESET_CAMPAIGN.value, sagas.resetCampaignSaga);
  yield takeLatest(EMAIL_CAMPAIGN_CREATE_CAMPAIGN.value, sagas.createEmailCampaignSaga);
  yield takeLatest(EMAIL_CAMPAIGN_PREPAYMENT_GET.value, sagas.getPrepaymentSaga);
  yield takeLatest(EMAIL_CAMPAIGN_VALUATION_SENSITIVITY_GET.value, sagas.getValuationSensitivitySaga);
  yield takeLatest(EMAIL_CAMPAIGN_GET_PREPAYMENT_SNAPSHOT.value, sagas.getPrepaymentSnapshotSaga);
  yield takeLatest(EMAIL_CAMPAIGN_GET_VALUATION_SNAPSHOT.value, sagas.getValuationSensitivitySnapshotSaga);
  yield takeLatest(EMAIL_CAMPAIGN_GET_CAMPAIGN_TYPES.value, sagas.getCampaignTypesSaga);
  yield takeLatest(EMAIL_CAMPAIGN_GET_CAMPAIGNS.value, sagas.getEmailCampaignsSaga);
  yield takeLatest(EMAIL_CAMPAIGN_GET_MASTER_CONTACT_LIST.value, sagas.getMasterContactListSaga);
  yield takeLatest(EMAIL_CAMPAIGN_POST_MASTER_CONTACT_LIST.value, sagas.saveMasterContactListSaga);
  yield takeLatest(EMAIL_CAMPAIGN_GET_CAMPAIGN.value, sagas.getEmailCampaignSaga);
  yield takeLatest(EMAIL_CAMPAIGN_DELETE_CAMPAIGN.value, sagas.deleteEmailCampaignSaga);
  yield takeLatest(EMAIL_CAMPAIGN_UPDATE_CAMPAIGN.value, sagas.updateEmailCampaignSaga);
  yield takeLatest(EMAIL_CAMPAIGN_TOGGLE_DEAL_ACTIVE.value, sagas.toggleDealCampaignSaga);
  yield takeLatest(EMAIL_CAMPAIGN_IS_EMAIL_COMPOSED_FLAG_TOGGLE.value, sagas.toggleCampaignEmailIsComposedFlagSaga);
  yield takeLatest(EMAIL_CAMPAIGN_UPDATE_EMAIL.value, sagas.updateEmailCampaignEmailSaga);
}
